// @ts-nocheck
import groupBy from "json-groupby";
import { SCHEDULE_DATA } from "./data";
import { countryCodes } from "./countryCodes";
//This function removes duplicates from an array of objects
//using the object key
export const replaceAll = "".replaceAll
  ? (str, find, rep) => str.replaceAll(find, rep)
  : (str, find, rep) => str.split(find).join(rep);
export function getUnique(arr, key) {
  const unique = arr
    .map((object) => object[key])

    // store the keys of the unique objects
    .map((e, i, final) => final.indexOf(e) === i && i)

    // eliminate the dead keys & store unique objects
    .filter((e) => arr[e])
    .map((e) => arr[e]);

  return unique;
}

export const isDefined = (elem) => typeof elem !== "undefined";

/**
 * Breaks an array into
 * @param {Array[*]} array The array that is to be grouped into smaller arrays
 * @param {String} size The maximum number of elements in each chunked array
 *
 * @returns {Array[Arrays]} An array of smaller, chunked arrays
 *
 * @example
 * chunkArray(["a","b","c","d"], 2)
 * //=> [["a","b"],["c","d"]]
 */
export function chunkArray(array, size) {
  let results = [];

  while (array.length > 0) results.push(array.splice(0, size));

  return results;
}

export function shuffle(array) {
  var currentIndex = array.length,
    temporaryValue,
    randomIndex;

  // While there remain elements to shuffle...
  while (0 !== currentIndex) {
    // Pick a remaining element...
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex -= 1;

    // And swap it with the current element.
    temporaryValue = array[currentIndex];
    array[currentIndex] = array[randomIndex];
    array[randomIndex] = temporaryValue;
  }

  return array;
}

/**
 * Returns the duplicate elements in an array
 * @param {Array} arr Array that has duplicate elements
 * @returns {Array} Duplicate elements
 */
export function getArrayDuplicates(arr) {
  return arr.filter((elem, index, array) => array.indexOf(elem) !== index);
}

/**
 * Checks if an array contains nested arrays or not.
 * @param {Array[]} arr
 * @returns {Boolean}
 * @example
 * isNestedArray([["a","b"],["c","d"]])
 * //=> true
 */
export function isNestedArray(arr) {
  let nestedArrays = arr.filter((item) => Array.isArray(item));
  return nestedArrays.length > 0;
}

export function scrollToTop(style?: ScrollBehavior) {
  return window.scroll({
    top: 0,
    behavior: style ? style : "auto",
  });
}

export function capFirstLetter(str: string | string[]) {
  let ss = str;
  if (Array.isArray(str)) {
    ss = str.join(",");
  }
  return ss.charAt(0).toUpperCase() + ss.slice(1);
}

// This component renders a title, description, icon, badge, and hide/show link
// as well as a renderElement on the Right and Left

export function removeClassPrefix(word) {
  return word
    .replace(/Primary /g, "")
    .replace(/JSS /g, "")
    .replace(/SSS /g, "");
}

export const toTitleCase2 = (str = "") => {
  let i, j, lowers, uppers;
  str = str.replace(/([^\W_]+[^\s-]*) */g, function (txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
  // if (str) {
  //   str
  //     .split(" ")
  //     .map((w) => w.substring(0, 1).toUpperCase() + w.substring(1))
  //     .join(" ")
  //     .split(",")
  //     .map((w) => w.substring(0, 1).toUpperCase() + w.substring(1))
  //     .join(", ")
  //     .split(".")
  //     .map((w) => w.substring(0, 1).toUpperCase() + w.substring(1))
  //     .join(". ");
  // }

  // Certain minor words should be left lowercase unless
  // they are the first or last words in the string

  lowers = [
    "A",
    "An",
    "The",
    "And",
    "But",
    "Or",
    "For",
    "Nor",
    "As",
    "At",
    "By",
    "For",
    "From",
    "In",
    "Into",
    "Near",
    "Of",
    "On",
    "Onto",
    "To",
    "With",
  ];

  for (i = 0, j = lowers.length; i < j; i++)
    str = str.replace(
      new RegExp("\\s" + lowers[i] + "\\s", "g"),
      function (txt) {
        return txt.toLowerCase();
      },
    );

  // Certain words such as initialisms or acronyms should be left uppercase
  uppers = ["Id", "Tv"];
  for (i = 0, j = uppers.length; i < j; i++)
    str = str.replace(
      new RegExp("\\b" + uppers[i] + "\\b", "g"),
      uppers[i].toUpperCase(),
    );

  return str;
};

export const toTitleCase = (str = "") => {
  const articles = ["a", "an", "the"];
  const conjunctions = ["for", "and", "nor", "but", "or", "yet", "so"];
  const prepositions = [
    "with",
    "at",
    "from",
    "into",
    "upon",
    "of",
    "to",
    "in",
    "for",
    "on",
    "by",
    "like",
    "over",
    "plus",
    "but",
    "up",
    "down",
    "off",
    "near",
  ];

  // The list of spacial characters can be tweaked here
  const replaceCharsWithSpace = (str = "") =>
    str.replace(/[^0-9a-z&/\\]/gi, " ").replace(/(\s\s+)/gi, " ");
  const capitalizeFirstLetter = (str = "") =>
    str.charAt(0).toUpperCase() + str.substr(1);
  const normalizeStr = (str = "") => str.toLowerCase().trim();
  const shouldCapitalize = (word, fullWordList, posWithinStr) => {
    if (posWithinStr == 0 || posWithinStr == fullWordList.length - 1) {
      return true;
    }

    return !(
      articles.includes(word) ||
      conjunctions.includes(word) ||
      prepositions.includes(word)
    );
  };

  str = replaceCharsWithSpace(str);
  str = normalizeStr(str);

  let words = str.split(" ");
  if (words.length <= 2) {
    // Strings less than 3 words long should always have first words capitalized
    words = words.map((w) => capitalizeFirstLetter(w));
  } else {
    for (let i = 0; i < words.length; i++) {
      words[i] = shouldCapitalize(words[i], words, i)
        ? capitalizeFirstLetter(words[i], words, i)
        : words[i];
    }
  }

  return words.join(" ");
};

/**
 * Sorts an array of objects in alphabetical order using the supplied `key`
 * @param {Array[{}]} array Array of objects to be ordered alphabetically
 * @param {String} key the object key to be used in the sorting
 * @returns A sorted Array
 * @example
 * orderAlphabetically([{food: "Yam", price: 500},{food: "Egg", price: 100}], "food")
 * //=> [{food: "Egg", price: 100}, {food: "Yam", price: 500}]
 */
export const orderAlphabetically = (array, key) => {
  return [...array].sort((a, b) => {
    if (a[key] < b[key]) return -1;
    if (a[key] > b[key]) return 1;
    return 0;
  });
};

/**
 * Checks if all the properties of an object have values
 * Applies to boolean, string, array or object values
 * @param {Object} obj - Object to be checked
 * @param {Object} deleteKey1 - A key to be disregarded
 * @param {Object} deleteKey2 - A key to be disregarded
 * @returns Boolean
 */

export function isValidObject(obj, deleteKey1 = "", deleteKey2 = "") {
  let objKeyValue = Object.entries(obj)
    .filter((keyValue) => keyValue[0] !== deleteKey1)
    .filter((keyValue) => keyValue[0] !== deleteKey2)
    .map((keyValue) => keyValue[1]);
  return objKeyValue.length > 0
    ? objKeyValue.every((item) =>
        Array.isArray(item)
          ? item.length > 0
          : typeof item === "object"
          ? isValidObject(item)
          : Boolean(item) || typeof item === "boolean",
      )
    : false;
}
/**
 * Groups an array of objects using a key into two arrays
 * one containing objects that have the key, and the other containing
 * objects that do not have the key.
 * @param {Array} array An array of objects containing properties to be grouped
 * @param {String} key  Name of the object key that will be used to group arrays
 * @example
 * groupArrayByKey([{food: "Yam", type: "Carbohydrate"},{food: "Beans", type: "Protein"},{food: "Rice", type: "Carbohydrate"},{food: "Vegetable", type: "vitamins"}],"Carbohydrate")
 * //=> {arrayWithKey: [{food: "Yam", type: "Carbohydrate"}, {food: "Rice", type: "Carbohydrate"}], arrayWithoutKey: [{food: "Beans", type: "Protein"}, {food: "Vegetable", type: "vitamins"}]}
 */
export function groupArrayByKey(array, key) {
  let firstKey = array[0][key];
  let arrayWithKey = array.filter((item) => item[key] === firstKey);
  let arrayWithoutKey = array.filter((item) => !arrayWithKey.includes(item));
  return { arrayWithKey, arrayWithoutKey };
}

/**
 * Chunks an array of objects into smaller arrays with similiar object keys
 * @param {Array} array
 * @param {String} key
 * @example
 * chunkArrayByKey([{food: "Yam", type: "Carbohydrate"},{food: "Beans", type: "Protein"},{food: "Rice", type: "Carbohydrate"},{food: "Vegetable", type: "vitamins"}],"Carbohydrate")
 * //=> [[{food: "Yam", type: "Carbohydrate"}, {food: "Rice", type: "Carbohydrate"}],[{food: "Beans", type: "Protein"}],[{food: "Vegetable", type: "vitamins"}]]
 */
export function chunkArrayByKey(array, key) {
  let result = [];
  let continueLoop = true;
  let startArr = array;

  let rr = groupBy(array, [key]);
  return Object.values(rr);
  console.log(rr);
  console.log(array);
  console.log(key);
  while (continueLoop) {
    let { arrayWithKey, arrayWithoutKey } = groupArrayByKey(startArr, key);
    if (arrayWithKey.length > 0) result.push(arrayWithKey);
    startArr = arrayWithoutKey;
    if (arrayWithoutKey.length === 0) continueLoop = false;
  }
  console.log(result);
  return result;
}

export function getRandomElemFromArray(array) {
  return array[Math.floor(Math.random() * array.length)];
}

export function newChunkArrayByKey(array, key) {
  let result = groupBy(array, [key]);
  return Object.entries(result);
}

/**
 * This combines an array of strings into a string output inserting
 * "," and "and" where appropriate
 * @param {Array} array
 *
 * @example
 * arrayToString(["a","b","c"])
 * //=>"a, b and c"
 */
export function arrayToString(array, separator = "and") {
  let string = "";

  array.forEach((x, i) => {
    if (i < array.length - 2) string = string.concat(x, ", ");
    if (i === array.length - 2) string = string.concat(x, ` ${separator} `);
    if (i > array.length - 2) string = string.concat(x);
  });

  return string;
}

/* Given a start date, end date and day name, return
 ** an array of dates between the two dates for the
 ** given day inclusive
 ** @param {Date} start - date to start from
 ** @param {Date} end - date to end on
 ** @param {string} dayName - name of day
 ** @returns {Array} array of Dates
 */
export function getDaysBetweenDates(start, end, dayName) {
  let result = [];
  let days = {
    sunday: 0,
    monday: 1,
    tuesday: 2,
    wednesday: 3,
    thursday: 4,
    friday: 5,
    saturday: 6,
  };
  let day = days[dayName.toLowerCase()];
  // Copy start date
  let current = new Date(start);
  // Shift to next of required days
  current.setDate(current.getDate() + ((day - current.getDay() + 7) % 7));
  // While less than end date, add dates to result array
  while (current < end) {
    result.push(+current);
    current.setDate(current.getDate() + 7);
  }
  return result;
}

export const scrollToId = (id, scrollProps = {}, timeout = 300) => {
  let section = document.getElementById(id);
  let scrollObj: any = {
    block: "start",
    inline: "start",
    behavior: "smooth",
    ...scrollProps,
  };
  if (section) {
    setTimeout(() => {
      section.scrollIntoView(scrollObj);
    }, timeout);
  }
};

export function getReadableDate(isoDate) {
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  const d = new Date(isoDate);
  const monthName = months[d.getMonth()];
  const day = d.getDate();
  const year = d.getFullYear();
  return `${monthName} ${day}, ${year}`;
}

/**
 * Calculates the standard deviation
 * @param {Array[]} values Array of numbers
 */
export function standardDeviation(values) {
  let avg = average(values);

  let squareDiffs = values.map((value) => {
    let diff = value - avg;
    let sqrDiff = diff * diff;
    return sqrDiff;
  });

  let avgSquareDiff = average(squareDiffs);

  return Math.sqrt(avgSquareDiff);
}

/**
 * Calculates the mean
 * @param {Array[]} data Array of numbers
 */
export function average(data) {
  let sum = data.reduce((sum, value) => {
    return sum + value;
  }, 0);

  return sum / data.length;
}

export function numberWithCommas(x = "") {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export const possessiveNoun = (name) => {
  if (name.charAt(name.length - 1) === "s") return `${name}'`;
  return `${name}'s`;
};

export const removeElementFromArray = (item, array) => {
  const newArray = [...array];
  const index = newArray.indexOf(item);
  if (index > -1) {
    newArray.splice(index, 1);
  }
  return newArray;
};

export function getlength(number) {
  return number.toString().length;
}

export const getLessonTime = ({ lessonTime, lessonHours = 0 }) => {
  let hours = Math.trunc(parseFloat(lessonHours));
  let minutes = parseFloat(lessonHours) - hours ? 30 : 0;
  let startTime = lessonTime.split(" ")[0];
  let timeOfDay = lessonTime.split(" ")[1];
  let startTimeHour = parseInt(startTime.split(":")[0]);
  let startTimeMin = parseInt(startTime.split(":")[1]);
  let endHours = startTimeHour + hours;
  let isNoon = endHours >= 12 && endHours < 13;
  let endTimeHours = isNoon ? endHours : (startTimeHour + hours) % 12;
  let endTimeMins = (startTimeMin + minutes) % 60;
  if (isNoon) {
    timeOfDay = "PM";
  } else {
    if (endTimeHours < startTimeHour) {
      timeOfDay = timeOfDay === "PM" ? "AM" : "PM";
    }
  }

  if (!endTimeMins && !minutes)
    return `${lessonTime} - ${endTimeHours}:00 ${timeOfDay}`;

  if (!endTimeMins && minutes)
    return `${lessonTime} - ${endTimeHours + 1}:00 ${timeOfDay}`;

  return `${lessonTime} - ${endTimeHours}:${endTimeMins} ${timeOfDay}`;
};

export const getElapsedTime = (
  startTime = new Date(),
  endTime = new Date(),
) => {
  let timeDiff = endTime.getTime() - startTime.getTime();

  timeDiff = timeDiff / 1000;
  let seconds = Math.floor(timeDiff % 60);
  let secondsAsString = seconds < 10 ? "0" + seconds : seconds;

  timeDiff = Math.floor(timeDiff / 60);
  let minutes = timeDiff % 60;
  let minutesAsString = minutes < 10 ? "0" + minutes : minutes;

  timeDiff = Math.floor(timeDiff / 60);
  let hours = timeDiff % 24;
  timeDiff = Math.floor(timeDiff / 24);

  let days = timeDiff;

  let totalHours = hours + days * 24; // add days to hours
  let totalHoursAsString = totalHours < 10 ? "0" + totalHours : totalHours;

  if (totalHoursAsString === "00") {
    return minutesAsString + ":" + secondsAsString;
  } else {
    return totalHoursAsString + ":" + minutesAsString + ":" + secondsAsString;
  }
};

export function addDays(date, days) {
  var result = new Date(date);
  result.setDate(result.getDate() + days);
  return result;
}

export function greetings(currentTime) {
  if (currentTime >= 0 && currentTime < 12) return "Good morning";
  if (currentTime > 12 && currentTime < 17) return "Good afternoon";
  if (currentTime >= 17 && currentTime < 24) return "Good evening";
  return "Hello";
}

export const getWeekDay = (date: any, dayType = "") => {
  if (date) {
    const result = SCHEDULE_DATA.daysOfTheWeek.find(
      (weekDay) => weekDay.index === new Date(date).getDay(),
    );
    return dayType ? result[dayType] : result.longDay;
  }
  return "";
};

export const formatDate = (dateString) => {
  const date = new Date(dateString);
  if (isNaN(date) === false) {
    return date;
  }
};

export const pipeFunc =
  (...fns) =>
  (x) =>
    fns.reduce((y, f) => f(y), x);

export const formatVicinity = (vicinity, region, state) => {
  const excludeCharacters = [
    "/",
    "(",
    ")",
    "&",
    "!",
    "-",
    "%",
    "*",
    "@",
    "^",
    "<",
    ">",
    "~",
    "|",
    "{",
    "}",
    "[",
    "]",
  ];
  const removeRegionState = [
    `, ${region}`,
    `, ${state}`,
    `,${region}`,
    `,${state}`,
    region,
    state,
  ];

  removeRegionState.forEach((word) => {
    vicinity = replaceAll(vicinity.toLowerCase(), word.toLowerCase(), "");
    // vicinity = vicinity.toLowerCase().replaceAll(word.toLowerCase(), "");
  });
  if (vicinity.trim()) {
    let vicinities = vicinity.split(",");
    let vv = vicinities[vicinities.length - 1].trim();
    if (excludeCharacters.includes(vv.charAt(0))) vv = vv.substring(1);
    if (excludeCharacters.includes(vv.charAt(vv.length - 1))) {
      vv = vv.substring(0, vv.length - 1);
    }

    return toTitleCase(vv.trim());
  }
  return region;
};

export const getCountryDialCode = (nationality: string) => {
  const dialCode = countryCodes.find((country) => country.name === nationality)
    ?.dial_code;
  return dialCode;
};

export const formatCurrency = (currency, formatType = "string") => {
  if (!!currency) {
    let value = Number(currency.replace(/[^0-9.-]+/g, ""));
    if (value & (formatType !== "string")) {
      return value;
    } else {
      return value.toString();
    }
  }
  return "";
};

export const formatPrice = (
  amount,
  currency = "NGN",
  locale = "en-NG",
  maxDigits = 2,
  minDigits = 0,
) => {
  if (!!amount) {
    const formatter = new Intl.NumberFormat(locale, {
      style: "currency",
      currency,
      minimumFractionDigits: minDigits,
      maximumFractionDigits: maxDigits,
    });

    return formatter.format(Number(amount));
  }
  return "";
};


function getOrdinal(n: number): string {
    const s = ['th', 'st', 'nd', 'rd'];
    const v = n % 100;
    return s[(v - 20) % 10] || s[v] || s[0];
}

export function formatAgreementDate(date: Date): string {
    const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

    const dayName = days[date.getDay()];
    const monthName = months[date.getMonth()];
    const dayOfMonth = date.getDate();
    const year = date.getFullYear();

    return `${dayName}, ${dayOfMonth}${getOrdinal(dayOfMonth)} of ${monthName}, ${year}`;
}